import { Entidade } from "app/anuncio/models/entidade.model";
import { Orgao } from "app/anuncio/models/orgao.model";

export class FiltroCadastroUsuarioGoverno {
  cpf: string;
  nome: string;
  entidade: Entidade;
  orgao: Orgao;
}
